import { backendAPI } from '../../helper/apis';

export const fetchVoucherStatus = (packagePurchaseID) => {
  return backendAPI.get(`/packpurchase/voucher/status/${packagePurchaseID}`);
}